<template>
  <div v-if="showModal" class="modal-container-1" @click="closeModal">
    <div class="modal-content-1" @click="(e) => e.stopPropagation()">
      <div class="modal-header-1">
        <h4 style="margin: 0">{{ $t('modal.send_email') }}</h4>
        <span>
          <img :src="Close" alt="Close Icon" @click="closeModal" style="cursor: pointer" />
        </span>
      </div>
      <div class="modal-body-1">
        <div class="mb-1 group-mails card-to-show">
          <div class="groups-header">
            <label style="margin: 0; font-weight: 600">{{ $t('modal.select_groups') }}</label>
          </div>
          <div class="multiSelect-container">
            <span>{{ $t('modal.groups') }}</span>
            <multiselect
              v-model="share.modelgroup"
              :options="
                getWebtvGroups.map((group) => {
                  return {
                    ...group,
                    role: 'listener',
                  };
                })
              "
              :multiple="true"
              track-by="id"
              label="name"
              placeholder=""
              :close-on-select="false"
              :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
              :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
              :selected-label="$t('shareLink.selected')"
            >
              <span slot="noResult">{{
                $t('form_live.tabs.advanced.contributors.no_result')
              }}</span>
              <span slot="noOptions">{{
                $t('form_live.tabs.advanced.contributors.no_options')
              }}</span>
              <template v-slot:tag="{ option, remove }">
                <div class="custom-tag">
                  <span>{{ option.name }}</span>
                  <select
                    class="select-input"
                    :value="option.role"
                    @change="(e) => groupRoleHandler(e, option.id)"
                  >
                    <option value="listener">{{ $t('shareLink.listener') }}</option>
                    <option v-if="!getLive.isPearl" value="participant">
                      {{ $t('shareLink.participant') }}
                    </option>
                    <option value="moderator">{{ $t('shareLink.moderator') }}</option>
                    <!-- <option value="journalist">{{ $t("shareLink.journalist") }}</option> -->
                  </select>
                  <span @click="remove(option)" class="close-icon">
                    <font-awesome-icon
                      class="actionIcons icon-add-email"
                      :icon="{ prefix: 'fas', iconName: 'times' }"
                      style="cursor: pointer"
                    />
                  </span>
                </div>
              </template>
            </multiselect>
            <span> {{ $t('modal.users') }} </span>
            <multiselect
              v-model="share.modelWebtvUsers"
              :options="
                getWebtvUsers.map((user) => {
                  return {
                    ...user,
                    role: 'listener',
                  };
                })
              "
              :multiple="true"
              track-by="id"
              label="email"
              placeholder=""
              :close-on-select="false"
              :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
              :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
              :selected-label="$t('shareLink.selected')"
            >
              <span slot="noResult">{{
                $t('form_live.tabs.advanced.contributors.no_result')
              }}</span>
              <span slot="noOptions">{{
                $t('form_live.tabs.advanced.contributors.no_options')
              }}</span>
              <template v-slot:tag="{ option, remove }">
                <div class="custom-tag">
                  <span>{{ option.email }}</span>
                  <select
                    class="select-input"
                    :value="option.role"
                    @change="(e) => userRoleHandler(e, option.id)"
                  >
                    <option value="listener">{{ $t('shareLink.listener') }}</option>
                    <option v-if="!getLive.isPearl" value="participant">
                      {{ $t('shareLink.participant') }}
                    </option>
                    <option value="moderator">{{ $t('shareLink.moderator') }}</option>
                    <!-- <option value="journalist">{{ $t("shareLink.journalist") }}</option> -->
                  </select>
                  <span @click="remove(option)" class="close-icon">
                    <font-awesome-icon
                      class="actionIcons icon-add-email"
                      :icon="{ prefix: 'fas', iconName: 'times' }"
                      style="cursor: pointer"
                    />
                  </span>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="emails-list">
          <label>{{ $t('modal.send_group_mails.insert_mails.label') }}</label>
          <div class="tags-input">
            <div v-for="(tag, index) in share.emails" :key="index" class="tag">
              {{ tag.email }}
              <select class="select-input" :value="tag.role" @change="(e) => roleHandler(e, index)">
                <option value="listener">{{ $t('shareLink.listener') }}</option>
                <option v-if="!getLive.isPearl" value="participant">
                  {{ $t('shareLink.participant') }}
                </option>
                <!-- <option value="journalist">{{ $t("shareLink.journalist") }}</option> -->
              </select>

              <span @click="share.emails.splice(index, 1)" class="close-icon">
                <font-awesome-icon
                  class="actionIcons icon-add-email"
                  :icon="{ prefix: 'fas', iconName: 'times' }"
                />
              </span>
            </div>
            <input
              style="border: none; outline: none; padding: 5px; flex-grow: 1"
              type="text"
              :placeholder="$t('shareLink.emails_placeholder')"
              v-model="emailInput"
              @keyup.enter="changeEmails"
            />
          </div>
        </div>
        <div class="buttons_container-1">
          <button class="cancel_button" @click="closeModal">{{ $t('button.cancel') }}</button>
          <button class="send_button" @click="sendsharelink">
            {{ $t('button.send') }}

            <span v-if="loading" class="loader"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Close from './../../assets/icons/Close.svg';
import common from '../../helpers/common';
import VueSelect from 'vue-select';
import { mapActions, mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import 'vue-select/src/scss/vue-select.scss';
import i18n from '../../i18n/index.js';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import VueMoment from 'vue-moment';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import Toasted from 'vue-toasted';
import ClickOutside from 'vue-click-outside';
import HasPermission from '../../directives/HasPermission.js';

import UploadMixin from '../../mixins/UploadMixin.js';
import UtilsMixin from '../../mixins/UtilsMixin.js';
import ActionsButtons from '../../components/components/ActionButtons';
import RatingStars from '.././components/RatingStars';
import LikeDislike from '.././components/LikeDislike';
import InputTag from 'vue-input-tag';
import '../../assets/scss/nprogress.scss';
import Multiselect from 'vue-multiselect';
var moments = require('moment');
export default {
  name: 'ShareLink',
  components: {
    'v-select': VueSelect,
    VuePerfectScrollbar,
    VueMoment,
    moment,
    Toasted,
    ActionsButtons,
    RatingStars,
    LikeDislike,
    InputTag,
    Multiselect,
  },
  directives: {
    ClickOutside,
    HasPermission,
  },
  mixins: [UploadMixin, UtilsMixin],
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  data() {
    return {
      Close: Close,
      loading: false,
      showPassword: false,
      emailInput: '',
      dateToSend: new Date(),
      share: {
        user: '',
        modelgroup: [],
        modelUser: [],
        modelWebtvUsers: [],
        startDate: new Date(),
        emails: [],
        private: false,
        pwd: '',
        shareLink: '',
        liveId: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      allLives: 'lives/getAllLives',
      getContributors: 'lives/getContributors',
      getLive: 'lives/getLive',
      getTotalLive: 'lives/getTotalLive',
      isBusy: 'lives/getIsLoading',
      getInfoDetailLive: 'lives/getInfoDetailLive',
      getLinkExportLives: 'lives/getLinkExportLives',
      getSubscriptionUser: 'lives/getSubscriptionUser',
      getSubscriptionGroupUsers: 'lives/getSubscriptionGroupUsers',
      getWebtvUsers: 'lives/getWebtvUsers',
      getWebtvGroups: 'lives/getWebtvGroups',
      getUseJitsi: 'common/getUseJitsi',
      getDiffusionObject: 'lives/getDiffusionObject',
      getLinkArchivedVideo: 'lives/getLinkArchivedVideo',
      getDiffusion: 'common/getDiffusion',
      me: 'common/getUserName',
      getDataShareLink: 'lives/getDataShareLink',
      id: 'lives/getLiveId',
      showModal: 'common/getShowModal',
    }),
    getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    },
  },
  methods: {
    ...mapActions('lives', ['apiSendDataMail']),

    ...mapActions({
      paginate: 'lives/paginate',
      getAllContributors: 'lives/fetchContributors',
      deleteMultiLive: 'lives/deleteMultiLive',
      deleteLiveById: 'lives/deleteLiveById',
      setDisableLiveById: 'lives/setDisableLiveById',
      setEnableLiveById: 'lives/setEnableLiveById',
      getLiveById: 'lives/getLiveById',
      getInfosDetail: 'lives/getInfosDetail',
      getLinkExport: 'lives/getLinkExport',
      getSubscriptionUserList: 'lives/getSubscriptionUserList',
      getSubscriptionGroupUsersList: 'lives/getSubscriptionGroupUsersList',
      getWebtvUsersList: 'lives/getWebtvUsersList',
      getWebtvGroupsList: 'lives/getWebtvGroupsList',
      sendInvitationsMails: 'lives/sendInvitationsMails',
      sendInvitationsGroupMails: 'lives/sendInvitationsGroupMails',
      setScreenShare: 'lives/setScreenShare',
      getUrlDownloadFile: 'lives/getUrlDownloadFile',
      setDiffusionObject: 'lives/setDiffusionObject',
      setLives: 'lives/setLives',
      removeLiveById: 'lives/removeLiveById',
      isArchivedLive: 'lives/isArchivedLive',
      setDiffusion: 'common/setDiffusionLive',
      setShowModal: 'common/setShowModal',
    }),
    getNamePermalink(index) {
      if (index === 0) {
        return i18n.t('modal.export.permalink');
      } else {
        return i18n.t('modal.export.standAlone');
      }
    },
    disablePastDays(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = moment(date, 'DD MMM YYYY').toDate();
      selectedDate.setHours(0, 0, 0, 0);
      return selectedDate < today;
    },
    async sendsharelink() {
      let message;
      try {
        this.loading = true;
        this.share.shareLink = this.getDataShareLink;
        this.share.user = this.me;
        this.share.liveId = this.id;

        if (
          !this.share.emails.length &&
          !this.share.modelgroup.length &&
          !this.share.modelWebtvUsers.length
        ) {
          message = i18n.t('toast.no_emails_provided');
          this.showToast('error', message, 'icon-warning');
          this.loading = false;
          return;
        }

        if (!this.dateToSend) {
          message = i18n.t('toast.no_date_provided');
          this.showToast('error', message, 'icon-warning');
          this.loading = false;
          return;
        }

        const webtvUsersEmails = this.share.modelWebtvUsers.map((user) => {
          return {
            email: user.email,
            role: user.role,
            nom: user.firstName,
            prenom: user.lastName,
          };
        });

        const emails = [...this.share.emails, ...webtvUsersEmails];
        const groups = this.share.modelgroup.map((group) => {
          return { id: group.id, role: group.role };
        });

        const dataToSend = {
          groups: groups,
          live_id: this.share.liveId,
          emails: emails,
          live_description: this.getLive.description,
        };

        console.log('data to send : ', dataToSend);

        await axios.post(
          `${window.process.env.API_HOST_LIVE}/live/send-live-invitation`,
          dataToSend,
          {
            headers: {
              Authorization: `Bearer ${process.env.API_TOKEN}`,
            },
          },
        );
        message = i18n.t('toast.success_send_link');
        this.loading = false;
        this.$root.$emit('bv::hide::modal', 'modal-send-group-mails-row');
        this.showToast('success', message, 'icon-success');
      } catch (e) {
        console.log('ERROR: sending mail', e);
        this.loading = false;
        message = i18n.t('toast.error');
        this.showToast('error', message, 'icon-warning');
      }
    },
    changeEmails() {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (this.emailInput.trim() !== '' && emailRegex.test(this.emailInput.trim())) {
        this.share.emails.push({
          email: this.emailInput.trim(),
          role: 'listener',
        });
        this.emailInput = '';
      }
    },
    roleHandler(e, index) {
      this.share.emails[index].role = e.target.value;
    },
    userRoleHandler(e, id) {
      const index = this.share.modelWebtvUsers.findIndex((user) => user.id === id);
      this.share.modelWebtvUsers[index].role = e.target.value;
    },
    groupRoleHandler(e, id) {
      const index = this.share.modelgroup.findIndex((group) => group.id === id);
      this.share.modelgroup[index].role = e.target.value;
    },
    closeModal() {
      this.share.emails = [];
      this.share.modelgroup = [];
      this.share.modelWebtvUsers = [];
      this.setShowModal(false);
    },
  },
  async mounted() {
    moment.locale('en');
    this.getWebtvUsersList();
    this.getWebtvGroupsList();
  },
};
</script>

<style lang="scss">
@import '~styles/theme';
@import '../../assets/scss/nprogress.scss';
@import 'vue-multiselect/dist/vue-multiselect.min.css';

.modal-container-1 {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: grid;
  place-items: center;
  z-index: 6;
  background: rgba(0, 0, 0, 0.5);

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
}

.modal-content-1 {
  width: clamp(400px, 50%, 600px);
  height: auto;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

  @media screen and (max-width: 410px) {
    width: clamp(300px, 50%, 600px);
  }

  .modal-header-1 {
    padding: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    color: white;
    justify-content: space-between;
    background-color: #2d323e;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
}

.emails-list {
  padding: 10px;

  label {
    margin: 0;
  }

  .tags-input {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 5px;
    border-bottom: 1px solid #d1d1d1;
    padding: 10px 0;
    max-height: 100px;
    overflow-y: auto;

    .tag {
      display: flex;
      align-items: center;
      word-break: break-all;
      background-color: #f6f8fa;
      font-style: italic;
      padding: 5px;
      border-radius: 15px;
      gap: 5px;

      .close-icon {
        cursor: pointer;
        padding: 0 5px;
      }

      select {
        margin-left: auto;
      }
    }

    input {
      border: none;
      outline: none;
      padding: 5px;
      width: 100%;
      box-sizing: border-box;
    }
  }
}

.buttons_container-1 {
  padding: 10px;
  width: 100%;
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  align-items: center;

  .send_button {
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 10px;
    background: #3b75cb;
    padding: 10px 20px;
    color: white;
    border: 0;
    outline: none;
  }

  .cancel_button {
    padding: 10px 20px;
    border-radius: 10px;
    color: #62626b;
    background-color: transparent;
    border: 0;
    outline: none;
  }
}

.modal-body-1 {
  background-color: white;
  padding: 7px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  max-height: 600px;
  overflow-y: auto;
}

.groups-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;
}

.multiSelect-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.multiselect__tags-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
  padding: 5px 0;
  max-height: 100px;
  overflow-y: auto;
}

.add-emails-button {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid #42a4ff;
  color: #42a4ff;
  background-color: transparent;
  padding: 7px;
  border-radius: 10px;

  @media screen and (max-width: 768px) {
    padding: 3px;
    border-radius: 5px;

    span {
      display: none;
    }
  }
}

.checkbox {
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 0.5em 0;

  img {
    cursor: pointer;
  }
}

.custom-tag {
  background-color: #f6f8fa;
  border-radius: 15px;
  display: inline-block;
  margin-right: 3px;
  padding: 5px;
}

.select-input {
  background: none;
  border: 0;
  color: #1688f2;
  font-style: italic;
}

.loader {
  width: 15px;
  height: 15px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/shareLink.vue